/* eslint-disable no-undef */

import React, {Component} from 'react'
import {withStyles} from "@material-ui/core/styles/index";
import parse from 'html-react-parser';
import AutoSuggest from "../simple/AutoSuggest";
import {getCompanySuggestions} from "../../../api"
import {styles} from './CompanySelect.styles'
import TextQuestion from "./Text";

import { Grid, FormLabel, Link, FormHelperText, Typography } from '@material-ui/core';

class CompanySelectQuestion extends Component {
    state = {
        selectedCompany: null,
        companyEditOpen: true,
        showBusinessIdInput: false,
        showCompanyNotFoundPrompt: false,
    }

    componentWillMount() {
        if (this.props.question && this.props.question.value) {
            this.setState({showBusinessIdInput: true})
        }
    }

    handleChange = (item) => {
        this.setState({selectedCompany: item, companyEditOpen: false})

        this.props.onValueChanged(this.props.question.id, item.business_id)
    };
    handleBusinessIdChange = (questionId, value) => {
        this.props.onValueChanged(questionId, value)
    }

    openCompanyEdit = () => {
        this.handleBusinessIdChange(this.props.question.id, null)
        this.setState({selectedCompany: null, companyEditOpen: true})
    }

    companyNotFound = (searchValue) => {
        this.setState({showCompanyNotFoundPrompt: true})
    }

    companiesFound = (searchValue) => {
        this.setState({showCompanyNotFoundPrompt: false})
    }

    onShowBusinessIdInput = () => {
        this.setState({showCompanyNotFoundPrompt: false, showBusinessIdInput: true})
    }

    render() {
        const {classes, value} = this.props;
        const {selectedCompany, companyEditOpen, showBusinessIdInput, showCompanyNotFoundPrompt} = this.state;

        let question = this.props.question
        if (showBusinessIdInput) {
            question.title = 'Yrityksen Y-tunnus'
        }
        return (
            <>
                <Grid item xs={parseInt(question.xsCols)} sm={parseInt(question.smCols)}
                      className={classes.questionWrapper}>
                    {false &&
                    <>{!question.titleSize && <FormLabel component="legend">{question.title}</FormLabel>}
                        {question.titleSize && <Typography variant={question.titleSize} gutterBottom
                                                           className={classes.customTitleSize}>{question.title}</Typography>}
                    </>}
                    {question.description &&
                    <Typography component="span">{parse(question.description)}</Typography>}
                    {selectedCompany &&
                    <Grid container spacing={1} className={classes.companyDetails}>
                        <Grid item xs={12} sm={12} style={{padding: 0}}>
                            <Typography className={classes.companyNameDetail}>{selectedCompany.name} <small>{selectedCompany.business_id}</small></Typography>
                        </Grid>
                        <Grid item xs={12} sm={12} style={{padding: 0}}>
                            <Typography className={classes.companyDetail}>{selectedCompany.address}</Typography>
                        </Grid>
                    </Grid>}
                    {companyEditOpen && !showBusinessIdInput && <>
                        <Grid container spacing={1}>
                            <AutoSuggest onChange={this.handleChange} getSuggestions={getCompanySuggestions} question={question}
                                         companyNotFound={this.companyNotFound} companiesFound={this.companiesFound}
                                         valid={question.valid}/>
                            {question.valid === false &&
                            <Grid item xs={12} style={{paddingTop: 0, paddingBottom: 0}}><FormHelperText
                                className={classes.errorText}>{question.errorMessage}</FormHelperText></Grid>}
                            {question.helperText &&
                            <Grid item xs={12} style={{
                                paddingTop: 0,
                                paddingBottom: 0
                            }}><FormHelperText>{question.helperText}</FormHelperText></Grid>}
                        </Grid>
                    </>}
                    {showCompanyNotFoundPrompt && <>
                        <Typography variant="body2" className={classes.suggestion}>Yritystä ei löytynyt hakemasi nimen
                            perusteella</Typography>
                        <Typography variant="body2" className={classes.businessIdToggle}>
                            <Link onClick={() => this.onShowBusinessIdInput()}>Syötä yrityksesi Y-tunnus klikkaamalla
                                tästä</Link>.
                        </Typography></>}
                    {showBusinessIdInput && <TextQuestion question={question} value={value}
                                                                    onValueChanged={this.handleBusinessIdChange}/>}
                    {!companyEditOpen &&
                    <div className={classes.changeCompany}><span
                        onClick={() => this.openCompanyEdit()}>Vaihda yritys</span></div>}
                </Grid>
            </>
        )
    }
}

export default withStyles(styles)(CompanySelectQuestion);
